export default __webpack_public_path__ + "static/media/dropdown-ic.6725e833.svg";